export { CustomButtonWithTranslator } from '../client/components/CustomButton/CustomButtonWithTranslator.js'
